"use strict";

exports.__esModule = true;
exports["default"] = exports.LinkContainer = exports.ButtonContainer = exports.ButtonBack = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("./utils");

var _excluded = ["disabled", "version"],
    _excluded2 = ["ctaStyle", "hover", "ui", "version"],
    _excluded3 = ["ui", "version"],
    _excluded4 = ["children", "className", "color", "data-test-id", "disabled", "forwardedAs", "mb", "mr", "handleClick", "handleMouseDown", "justifyContent", "size", "ui", "url", "version", "target", "width"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonContainer = (0, _styledComponents["default"])(function (_ref) {
  var disabled = _ref.disabled,
      version = _ref.version,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Button, props);
}).withConfig({
  displayName: "container__ButtonContainer",
  componentId: "sc-1f5sfyn-0"
})(["cursor:pointer;text-decoration:none;", ";", ";"], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? (0, _styledComponents.css)(["opacity:0.35;"]) : null;
}, function (_ref3) {
  var version = _ref3.version;
  return version === "primary" ? (0, _styledComponents.css)(["position:relative;"]) : null;
});
exports.ButtonContainer = ButtonContainer;
var ButtonBack = (0, _styledComponents["default"])(function (_ref4) {
  var ctaStyle = _ref4.ctaStyle,
      hover = _ref4.hover,
      ui = _ref4.ui,
      version = _ref4.version,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, props);
}).withConfig({
  displayName: "container__ButtonBack",
  componentId: "sc-1f5sfyn-1"
})(["display:inline-flex;", ";", ";"], (0, _styles.transitionEase)("0.7s", ["background-color", "color", "border-color", "opacity"]), function (_ref5) {
  var ui = _ref5.ui,
      version = _ref5.version,
      props = _objectWithoutPropertiesLoose(_ref5, _excluded3);

  return version === "link" ? (0, _utils.linkStyles)(props) : (0, _utils.buttonStyles)(Object.assign({
    ui: ui,
    version: version
  }, props));
});
exports.ButtonBack = ButtonBack;
var LinkContainer = (0, _styledComponents["default"])(ButtonContainer).withConfig({
  displayName: "container__LinkContainer",
  componentId: "sc-1f5sfyn-2"
})(["display:inline-block;"]);
exports.LinkContainer = LinkContainer;
var propTypes = {
  /** Button content, usually a text string, but can be a React component */
  children: _propTypes.node,

  /** Styled components generated className */
  className: _propTypes.string,

  /** A string which represents a color from the color library */
  color: _propTypes.string,

  /** Cypress test id */
  "data-test-id": _propTypes.string,

  /** A boolean to represent whether the cta should be disabled */
  disabled: _propTypes.bool,

  /**
   * Determines what to render for the CtaContainer.
   * Defaults to an anchor tag if a url prop is present and a <button> tag otherwise
   * Sometimes, Tag is a Link which is rendered as the function: MapProps.
   */
  forwardedAs: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]),

  /** A function that will be called when the button is clicked */
  handleClick: _propTypes.func,

  /** A function that will be called on mouse down */
  handleMouseDown: _propTypes.func,
  justifyContent: _propTypes.string,

  /** Margin bottom, implements style-system */
  mb: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),

  /** Margin right, implements style-system */
  mr: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),

  /** A function that will be called when the button is clicked */
  onClick: _propTypes.func,

  /** Cta size, determines which size styling to apply */
  size: _propTypes.string,

  /** Target for when Ctas are links, used for opening a new tab or window */
  target: _propTypes.string,

  /** A to determine whether the dark or light version of the cta is used */
  ui: _propTypes.string,

  /** Url provided to CtaContainer for links */
  url: _propTypes.string,

  /** Cta version, determines which version styles to apply */
  version: _propTypes.string,

  /** Determines Cta width, defaults to "auto", implements style-system */
  width: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number])
};

var CtaContainer = function CtaContainer(_ref6) {
  var children = _ref6.children,
      className = _ref6.className,
      color = _ref6.color,
      dataTestId = _ref6["data-test-id"],
      disabled = _ref6.disabled,
      forwardedAs = _ref6.forwardedAs,
      mb = _ref6.mb,
      mr = _ref6.mr,
      handleClick = _ref6.handleClick,
      handleMouseDown = _ref6.handleMouseDown,
      justifyContent = _ref6.justifyContent,
      _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? "large" : _ref6$size,
      _ref6$ui = _ref6.ui,
      ui = _ref6$ui === void 0 ? "light" : _ref6$ui,
      url = _ref6.url,
      _ref6$version = _ref6.version,
      version = _ref6$version === void 0 ? "secondary" : _ref6$version,
      target = _ref6.target,
      width = _ref6.width,
      props = _objectWithoutPropertiesLoose(_ref6, _excluded4);

  var Constructor = url ? LinkContainer : ButtonContainer;
  return /*#__PURE__*/_react["default"].createElement(Constructor, {
    className: className,
    "data-test-id": dataTestId,
    disabled: disabled,
    forwardedAs: forwardedAs,
    href: url,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    target: url && target,
    version: version,
    width: width
  }, /*#__PURE__*/_react["default"].createElement(ButtonBack, _extends({
    alignItems: "center",
    color: color,
    justifyContent: justifyContent,
    lineHeight: 0,
    mb: mb,
    mr: mr,
    ui: ui,
    version: version,
    width: width || "auto"
  }, (0, _utils.getSpacing)(version, size), (0, _utils.getUIColors)(ui, version), props), children));
};

CtaContainer.propTypes = propTypes;
CtaContainer.displayName = "Modules.CtaContainer";
var _default = CtaContainer;
exports["default"] = _default;